module.exports = __webpack_public_path__ + "static/media/404-heading.42b220a8.svg";